import { AdmService } from 'src/app/shared/services/adm.service';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { ConfigService } from 'src/app/shared/services/config.service';
import { Factura } from 'src/app/shared/models/factura';
import { isMobile, isMobileXL } from 'src/app/shared/utils/helpers';
import { LogAutorizacion } from 'src/app/shared/models/logAutorizacion';
import { LoggedService } from 'src/app/shared/services/logged.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NCService } from 'src/app/shared/services/nc.service';
import { NotaCreditoCabecera } from 'src/app/shared/models/notaCreditoCabecera';
import { PedidoVentaCabecera } from 'src/app/shared/models/pedidoVentaCabecera';
import { PedidoVentaRetencion } from 'src/app/shared/models/pedidoVentaRetencion';
import { PVService } from 'src/app/shared/services/pv.service';

@Component({
  selector: 'app-nc-facturas-dialog',
  templateUrl: './nc-facturas-dialog.component.html'
})
export class NCFacturasDialogComponent {

  displayedColumns = ['acciones', 'nroFactura', 'nroPedido', 'nroRemito', 'fechaVencimiento', 'totalFactura', 'idZonaVendedor', 'tipoOrden'];
  dataSource = new MatTableDataSource<Factura>();
  @ViewChild('matSort') matSort: MatSort;
  @ViewChild('matPaginator') matPaginator: MatPaginator;

  ncCab: NotaCreditoCabecera;

  constructor(
    private ncService: NCService,
    private configService: ConfigService,
    private loggedService: LoggedService,
    private admService: AdmService,
    private dialogRef: MatDialogRef<NCFacturasDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {

    if (data.cab != null) {
      this.ncCab = data.cab;
    }

  }

  public Etiquetas: {


    TipoOrden: string,
    NroFactura: string,
    TotalFactura: string,
    NroRemito: string,
    NroPedido: string,
    FechaVencimiento: string,
    IdZonaVendedor: string,
    Acciones: string
    SinRegistros: string
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.matPaginator;
    this.dataSource.sort = this.matSort;
    this.dataSource.sort.disableClear = true;
  }

  ngOnInit() {
    this.Etiquetas = {
      TipoOrden: this.configService.etiquetas.TipoOrden,
      SinRegistros: this.configService.etiquetas.SinRegistros,
      Acciones: this.configService.etiquetas.Acciones,
      NroPedido: this.configService.etiquetas.NroPedido,
      FechaVencimiento: this.configService.etiquetas.FechaVencimiento,
      TotalFactura: this.configService.etiquetas.TotalFactura,
      IdZonaVendedor: this.configService.etiquetas.ZonaVendedor,
      NroRemito: this.configService.etiquetas.NroRemito,
      NroFactura: this.configService.etiquetas.NroFactura,

    }
    if (this.ncCab != null) {

      this.ncService.cFacturas(this.ncCab.idPais, this.ncCab.idCompania, this.ncCab.idSalesOrg, this.ncCab.idDivision, this.ncCab.nroCliente, this.ncCab.nroClienteDistribuidor, this.ncCab.idZonaVendedor, this.ncCab.idTipoNC, this.ncCab.nroPedido).subscribe((data: Factura[]) => {

        this.dataSource.data = [];
        if (data != null) {
          this.dataSource.data = data;
        }

      });


    }
  }



  seleccionar(f: any) {
    this.dialogRef.close(f);
  }


  isMobileXL() {
    return isMobileXL();
  }

  isMobile() {
    return isMobile();
  }
  isInRole(rol: string): boolean {
    return this.loggedService.isInRole(rol);
  }


}
